import { API, graphqlOperation } from "aws-amplify";
import {
  ordersByUpdatedDate,
  getActiveDealers,
  getAllDayOrders,
  getMyOrderDetails,
  getCurrenOrderbyDealerId,
} from "../graphql/myQueries";

import CheckType from "../utilities/dateFormat/checkType";

const useListDashboardData = () => {
  let nextToken = "";
  let allDealers = [];
  let nextTokenOrders = "";

  /**
   * Return the list of sended orders
   */
  const getUpdatedOrders = async (nextT = "", myOrders = []) => {
    try {
      const result = await API.graphql(
        graphqlOperation(ordersByUpdatedDate, {
          order_type: "PRESENCIAL",
          status: "LISTO",
          nextToken: nextT,
        })
      );

      if (result.data.ordersByUpdatedDate.items.length !== 0) {
        var currentResult = result.data.ordersByUpdatedDate.items;
        currentResult.forEach((element) => {
          if (element.status !== "BASKET") {
            myOrders.push(element);
          }
        });
      }

      nextTokenOrders = result.data.ordersByUpdatedDate.nextToken;

      if (nextTokenOrders !== undefined && nextTokenOrders !== null) {
        await getUpdatedOrders(nextTokenOrders, myOrders);
      } else return myOrders;
    } catch (error) {
      console.log("Error [listeningUpdateOrders] ->", error);
      return [];
    }
  };

  const initialDealers = () => {
    allDealers = [];
    nextToken = "";
  };

  /**
   * @param {Array} recibedOrders orders received from DB
   * @returns Array with the same structure of recibedOrders but with the value deliveryState and kmDistance
   */
  function asignValuesLocalOrder(recibedOrders) {
    let orders = recibedOrders;
    orders.map((order) => {
      order["deliveryState"] = "none";
      order["kmDistance"] = 0;
    });
    return orders;
  }

  /**
   * Async function to listen updates in all orders where the level is not finished
   */
  const getAllActiveDealers = async (
    role = "deliveryman",
    nextT = null,
    limit = 1000
  ) => {
    try {
      var currentDateToString = CheckType("current");
      const result = await API.graphql(
        graphqlOperation(getActiveDealers, {
          role,
          nextToken: nextT,
          limit,
          date: currentDateToString,
        })
      );
      if (result.data.listAccounts.items.length != 0) {
        var currentResult = result.data.listAccounts.items;
        currentResult.forEach((element) => {
          const found = allDealers.find((dealer) => dealer.id === element.id);
          if (!found) allDealers.push(asignStatusDelivery(element));
        });
      }

      nextToken = result.data.listAccounts.nextToken;

      if (nextToken !== undefined && nextToken !== null) {
        await getAllActiveDealers("deliveryman", nextToken, 1000);
      }
    } catch (error) {
      console.log("Error [getAllActiveDealers]", error);
      return [];
    }
  };

  /**
   * @param {Object} dealer Dealer from DB
   * @returns Dealer with same structure of dealer but with the value statusDelivery
   */
  function asignStatusDelivery(dealerDB) {
    let dealer = dealerDB;
    dealer["statusDelivery"] = "none";
    return dealer;
  }

  /**
   * @param {Object} order Current Selected order
   */
  const reorderDealers = async (order) => {
    try {
      var addressFromCoords = "";
      //? obtener la direccion de la orden (FROM)
      if (
        order.shop_comments === "WISHES" ||
        order.shop_comments === "SOLUTIONS"
      ) {
        var addresses = [];
        addresses = JSON.parse(JSON.parse(order?.address)) ?? [0].name;

        addressFromCoords =
          addresses[0].coords[0] + "," + addresses[0].coords[1];
      } else {
        let responseCoords = JSON.parse(order?.shop_id?.address_coords);
        responseCoords =
          responseCoords.latitude + "," + responseCoords.longitude;
        addressFromCoords = responseCoords;
      }
      //? obtener la ubicación actual de los repartidores
      //? actualizar repartidores
      await getAllActiveDealers();
      var dealers = allDealers;
      var dealer_byVehicle = [
        {
          type: "b",
          order: 1,
          elements: [],
        },
        {
          type: "m",
          order: 2,
          elements: [],
        },
        {
          type: "c",
          order: 3,
          elements: [],
        },
      ];
      //? recorrer lista de repartidores y comparar su ubicacion con la de la orden
      //? statusDelivery (A - Cerca / B - No muy lejos / C - Lejos)
      dealers.map((dealer) => {
        dealer.delivery_transport === "Bicicleta"
          ? dealer_byVehicle[0].elements.push(dealer)
          : dealer.delivery_transport === "Motocicleta"
          ? dealer_byVehicle[1].elements.push(dealer)
          : dealer_byVehicle[2].elements.push(dealer);
      });
      //console.log(dealer_byVehicle);

      dealer_byVehicle.map((type) => {
        type.elements.map((dealer) => {
          asignDistance(dealer, addressFromCoords);
        });
      });

      return dealer_byVehicle;
    } catch (error) {
      console.log("Error [reorderDealers] ", error);
    }
  };

  /**
   * Function to reorder the list of dealers by distance
   * @param {Object} a First dealer
   * @param {Object} b Second dealer
   */
  const sortArrayDistance = (a, b) => {
    if (a.kmDistance > b.kmDistance) {
      return 1;
    }
    if (a.kmDistance < b.kmDistance) {
      return -1;
    }
    return 0;
  };

  /**
   * Function to reorder the list of dealers by vehicle type
   * @param {Object} a First type
   * @param {Object} b Second type
   */
  const sortArrayVehicleType = (a, b) => {
    if (a.order > b.order) {
      return 1;
    }
    if (a.order < b.order) {
      return -1;
    }
    return 0;
  };

  /**
   * Function to asign the distance between the order and the dealer and asign the statusDelivery(A, B, C)
   * @param {Object} dealer Information of the dealer
   * @param {String} pointFrom Current location from the order (String that contains the coordinates)
   */
  const asignDistance = async (dealer, pointFrom) => {
    if (!!dealer.current_location) {
      //? parsing de la ubicacion actual del repartidor
      let positionDealer = JSON.parse(dealer.current_location);
      //? obtener la distancia entre la ubicacion actual del repartidor y la de la orden
      let distance = await returnDistance(
        pointFrom,
        positionDealer.lat + "," + positionDealer.lng
      );
      if (distance <= 2) {
        dealer.statusDelivery = "A";
      } else if (distance <= 5) {
        dealer.statusDelivery = "B";
      } else {
        dealer.statusDelivery = "C";
      }
      dealer.kmDistance = parseFloat(distance);
    } else {
      // ? console.log("No hay ubicacion actual de delivery");
      dealer.statusDelivery = "D";
      dealer.kmDistance = 0;
    }
  };

  /**
   * Function to get the distance between two points
   * @param {String} from first point
   * @param {String} to second point
   */
  const returnDistance = async (from, to) => {
    try {
      //? convert to Array
      var fromCoords = from.split(",");
      var toCoords = to.split(",");
      //? convert to Float coords FROM
      var fromLat = parseFloat(fromCoords[0]);
      var fromLng = parseFloat(fromCoords[1]);
      //? convert to Float coords TO
      var toLat = parseFloat(toCoords[0]);
      var toLng = parseFloat(toCoords[1]);

      var R = 6371; // Radius of the earth in km

      function rad(x) {
        return (x * Math.PI) / 180;
      }

      var dLat = rad(toLat - fromLat);
      var dLon = rad(toLng - fromLng);

      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(rad(fromLat)) *
          Math.cos(rad(toLat)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);

      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      var d = R * c; // Distance in km

      return d.toFixed(3);
    } catch (error) {
      console.log("Error [returnDistance] ", error);
    }
  };

  const getOrderByDate = async (id, date, token) => {
    try {
      const result = await API.graphql(
        graphqlOperation(getAllDayOrders, {
          id,
          nextToken: token,
          date,
        })
      );
      if (result.data.getAccount.deliveryman_orders.items) {
        return result.data.getAccount.deliveryman_orders.items;
      } else {
        return [];
      }
    } catch (error) {
      console.log("Error [getOrderByDate] ", error);
      return [];
    }
  };

  const getCurrentOrder = async (id, date) => {
    try {
      const result = await API.graphql(
        graphqlOperation(getCurrenOrderbyDealerId, {
          id,
        })
      );
      if (result.data.getAccount.deliveryman_orders.items.length !== 0) {
        return result.data.getAccount.deliveryman_orders.items[0];
      } else {
        return [];
      }
    } catch (error) {
      console.log("Error [getOrderByDate] ", error);
      return [];
    }
  };

  const validateOrderToAssign = async (orderId, deliveryId) => {
    try {
      const result = await API.graphql(
        graphqlOperation(getMyOrderDetails, { id: orderId })
      );
      if (result) {
        if (
          result.data.getOrder.status === "LISTO" &&
          result.data.getOrder.level === "EN PROCESO" &&
          !result.data.getOrder.delivery_man_id
        )
          return true;
        else return false;
      }
      return false;
    } catch (error) {
      console.log("Error [validateOrderToAssign] ", error);
      return false;
    }
  };

  return {
    sortArrayDistance,
    getUpdatedOrders,
    getAllActiveDealers,
    reorderDealers,
    allDealers,
    getOrderByDate,
    validateOrderToAssign,
    initialDealers,
    getCurrentOrder,
    sortArrayVehicleType,
  };
};
export default useListDashboardData;
